import { CanDeactivateFn } from '@angular/router';
import { CollabScreenComponent } from '@libs/collaboration';
import { map, Observable, of } from 'rxjs';

export const collabUnsentMessagesGuard: CanDeactivateFn<CollabScreenComponent> = (
  component: CollabScreenComponent,
): Observable<boolean> => {
  if (component.hasPendingMessages()) {
    return component.handlePendingMessages().pipe(map((result) => !!result?.confirm));
  }

  if (component.speechRecognitionStatus() === 'recording') {
    component.onToggleDictation();
  }

  return of(true);
};
